import config from './config';
import type {Configtype, SelectableConfig, BaseConfig} from './type';
import {createExtendedFunction} from './type';
import {
	margeconfig,
	getLighterColor,
	compareObject,
	drawCross,
	formatData
} from './util/index';
import {ColorError} from './util/error';
let prettyLogconfig: Configtype = config;
let Log:any
let returnLog:any
function prettyLog() {
	function setconfig(newConfig: SelectableConfig<Configtype>) {
		if (Object.keys(newConfig).length === 0) {
			return;
		}
		const margedconfig = margeconfig(prettyLogconfig, newConfig);
		prettyLogconfig = margedconfig;
	}
	function base(content: any, title?: string | number) {
		const {infotitle, infoconfig} = getinfo('base', title);
		baseLog(content, infoconfig, infotitle);
	}
	function info(content: any, title?: string | number) {
		const {infotitle, infoconfig} = getinfo('info', title);
		baseLog(content, infoconfig, infotitle);
	}
	function success(content: any, title?: string | number) {
		const {infotitle, infoconfig} = getinfo('success', title);
		baseLog(content, infoconfig, infotitle);
	}
	function error(content: any, title?: string | number) {
		const {infotitle, infoconfig} = getinfo('error', title);
		baseLog(content, infoconfig, infotitle);
	}
	function warning(content: any, title?: string | number) {
		const {infotitle, infoconfig} = getinfo('error', title);
		// @ts-ignore
		if(import.meta.env.MODE === 'production'){
			if (prettyLogconfig.use.production){
				baseLog(content, infoconfig, infotitle);
			} else {
				return;
			}
		} else {
			baseLog(content, infoconfig, infotitle);
		}
	}
	function baseLog(
		content: any,
		baseConfig: BaseConfig,
		title: string | number,
	) {
		let hasborder = prettyLogconfig.hasborder;
		if(typeof content === 'object' && content !== null) {
			content = formatData(content, prettyLogconfig.maxDepth);
			hasborder = false; // 如果内容是对象，则不显示边框
		}
		console.log(
			`%c ${title} %c ${content} %c`,
			`background:${baseConfig.backgroundColor}; border:1px solid ${baseConfig.borderColor}; border-radius: 2px 0 0 2px; color:${baseConfig.titleColor}`,
			` ${hasborder ? `border: 1px dashed ${baseConfig.borderColor};` : ''};,
			padding: 1px;
			border-radius:0 2px 2px 0;
			color:${baseConfig.contentColor};
			`,
			`background: transparent`,
		);
	}
	function picture(imgurl: string) {
		// @ts-ignore
		if(import.meta.env.MODE === 'production' && !prettyLogconfig.use.production){
			return;
		}
		const img = new Image();
		img.src = imgurl;
		img.crossOrigin = 'anonymous'; // 设置跨域属性
		img.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			if (ctx) {
				const imgheigth = img.height;
				const imgwidth = img.width;
				if (
					imgheigth < prettyLogconfig.img.maxHeight &&
					imgwidth < prettyLogconfig.img.maxWidth
				) {
					canvas.width = imgwidth;
					canvas.height = imgheigth;
				} else if (
					imgheigth > prettyLogconfig.img.maxHeight &&
					imgwidth < prettyLogconfig.img.maxWidth
				) {
					const heightRatio =
						prettyLogconfig.img.maxHeight / imgheigth;
					canvas.width = imgwidth * heightRatio;
					canvas.height = prettyLogconfig.img.maxHeight;
				} else if (
					imgheigth < prettyLogconfig.img.maxHeight &&
					imgwidth > prettyLogconfig.img.maxWidth
				) {
					const widthRatio = prettyLogconfig.img.maxWidth / imgwidth;
					canvas.width = prettyLogconfig.img.maxWidth;
					canvas.height = imgheigth * widthRatio;
				} else {
					const heightRatio =
						prettyLogconfig.img.maxHeight / imgheigth;
					const widthRatio = prettyLogconfig.img.maxWidth / imgwidth;
					const ratio = Math.min(heightRatio, widthRatio);
					canvas.width = imgwidth * ratio;
					canvas.height = imgheigth * ratio;
				}
				ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
				let dataURL = canvas.toDataURL('image/png');
				console.log(
					'%c sup?',
					`background-image: url(${dataURL});
						background-repeat: no-repeat;
						background-size: ${canvas.width}px ${canvas.height}px;
						padding: ${canvas.height / 2}px ${canvas.width / 2}px;
						color: transparent;
					`,
				);
			}
		};
	}
	function equal(value1: any, value2: any) {
		// @ts-ignore
		if(import.meta.env.MODE === 'production' && !prettyLogconfig.use.production){
			return;
		}
		let flag = true;
		if (typeof value1 === 'object' && typeof value2 === 'object') {
			if (typeof value1 !== null && typeof value2 !== null) {
				if (value1 === value2) {
					flag = true;
				} else {
					flag = compareObject(value1, value2);
				}
			} else {
				flag = false;
			}
		} else {
			flag = value1 === value2;
		}
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		canvas.width = 20;
		canvas.height = 20;
		if (ctx) {
			ctx.fillStyle = 'white';
			ctx.fillRect(0, 0, canvas.width, canvas.height);
			if (flag) {
				ctx.fillStyle = 'green';
				// 3. 绘制绿色的对勾 √
				ctx.strokeStyle = 'green';
				ctx.lineWidth = 2;
				ctx.lineCap = 'round';

				// 绘制对勾的路径
				ctx.beginPath();
				ctx.moveTo(5, 10); // 起点坐标 (x1, y1)
				ctx.lineTo(9, 14); // 中间点坐标 (x2, y2)
				ctx.lineTo(15, 6); // 终点坐标 (x3, y3)
				ctx.stroke();
			} else {
				drawCross(ctx, canvas);
			}
			const imageUrl = canvas.toDataURL('image/png');
			console.log(
				`%c s %c ${JSON.stringify(value1)}===${JSON.stringify(value2)}`,
				`background-image: url(${imageUrl});
					background-repeat: no-repeat;
					background-size: ${canvas.width}px ${canvas.height}px;
					padding: ${canvas.height / 4}px ${canvas.width / 4}px;
					color: transparent;
					background-position: center;
				`,
				`
					margin-left: 5px;
					color: ${flag ? 'green' : 'red'};
					${prettyLogconfig.hasborder ? `border: 1px solid ${flag ? 'green' : 'red'};` : ''};,
					padding: 2px 2px;
					border-radius: 5px;
					font-weight: bold;
				`,
			);
		}
	}
	function getinfo(type: string, title?: string | number) {
		const temp =
			prettyLogconfig[
				type as keyof Pick<
					Configtype,
					'info' | 'success' | 'error' | 'warning'
				>
			];
		let infotitle = temp.title;
		if (title) infotitle = title;
		if (prettyLogconfig.heightLight) {
			// 示例：计算颜色 "yellow" 的亮色
			try {
				temp.contentColor = getLighterColor(temp.contentColor);
			} catch (error) {
				if (error instanceof ColorError) {
					console.error(
						`ColorError: ${error.message},配置有问题请输入正确的 颜色名称 或者 HEX格式(#ffffff)`,
					);
				} else {
					console.error(`Unexpected error: ${error}`);
				}
			}
		}
		return {
			infoconfig: temp,
			infotitle: infotitle,
		};
	}
	return {
		base,
		info,
		error,
		warning,
		picture,
		equal,
		success,
		setconfig,
	};
}
function linstener() {
	// @ts-ignore
	if (import.meta.hot) {
		// @ts-ignore
		import.meta.hot.on('json-update', (data) => {
			// @ts-ignore
			Log.setconfig(data);
            localStorage.setItem('log-jsondata', JSON.stringify(data));
		});
	}
}
function setreturn(){
	if(!localStorage.getItem("pre-log-jsondata") ){
        // @ts-ignore
        Log.setconfig(window.__JSON_CONFIG__);
		// @ts-ignore
        localStorage.setItem('pre-log-jsondata',JSON.stringify(window.__JSON_CONFIG__));
    } else {
		// @ts-ignore
        if(localStorage.getItem("pre-log-jsondata") === JSON.stringify(window.__JSON_CONFIG__)) {
            if (localStorage.getItem("log-jsondata")) {
                Log.setconfig(JSON.parse(localStorage.getItem("log-jsondata") || "{}"));
            } else {
				// @ts-ignore
                Log.setconfig(window.__JSON_CONFIG__);
            }
        } else {
			// @ts-ignore
            Log.setconfig(window.__JSON_CONFIG__);
			// @ts-ignore
            localStorage.setItem('pre-log-jsondata',JSON.stringify(window.__JSON_CONFIG__));
            localStorage.removeItem('log-jsondata');
        }
    }
	// 根据配置决定是否启用扩展功能
	if (prettyLogconfig.enabled) {
		Log.base = createExtendedFunction(Log.base, Log, 'base');
	} else {
		Log.base = function (...args:any) {
			console.log(...args);
		};
		Log.base = createExtendedFunction(Log.base, Log);
	}
	returnLog = Log.base;
}
// @ts-ignore
const baseLog: Function & {
	info: Function;
	error: Function;
	warning: Function;
	picture: Function;
	equal: Function;
	success: Function;
	setconfig: Function;
} = function () {
	Log = prettyLog();
	try {
		setreturn();
	} catch (error) {
		console.error('Error fetching configuration:', error);
		return function (...args: any) {
			console.log(...args);
		};
	}
};


linstener();
baseLog();

export default returnLog;




